// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IPermissions;
(function (IPermissions) {
    IPermissions["GOLD_PERMISSION"] = "gold";
    IPermissions["SILVER_PERMISSION"] = "silver";
})(IPermissions || (IPermissions = {}));
